import React from "react";

const Footer = () => {
  return (
    <footer className="App-footer">
      <p>
        made with 🖤 by{" "}
        <a href="https://wun.vc/id/zkpz" target={"blank"}>
          zkpz
        </a>
      </p>
    </footer>
  );
};

export default Footer;
